import { render, staticRenderFns } from "./ExistingLpaChangesDetails.vue?vue&type=template&id=706eb5a4"
import script from "./ExistingLpaChangesDetails.vue?vue&type=script&lang=js"
export * from "./ExistingLpaChangesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports